module.exports = __webpack_public_path__ + "5c114213/img/print-icon.d8dbbca5.svg";